module.exports = __webpack_public_path__ + "img/Lego_Kids_cs.0811fe90.png";